import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container } from '@ttstr/components';
import CustomerResetPassword from '@ttstr/components/Customer/CustomerResetPassword';

interface RouteParams {
  token: string;
}

const ResetPassword: React.FC = () => {
  const { t } = useTranslation();
  const params = useParams<RouteParams>();

  return (
    <article className="mt-5 password-reset">
      <Container>
        <Helmet>
          <title>{t(`PASSWORD_RESET.TITLE`)}</title>
        </Helmet>
        <h1 className="text-center mb-5">{t(`PASSWORD_RESET.TITLE`)}</h1>

        <Row>
          <Col lg={{ size: 6, offset: 3 }}>
            <CustomerResetPassword token={params.token} />
          </Col>
        </Row>
      </Container>
    </article>
  );
};

export default React.memo(ResetPassword);
